import Context, {
    AppContext,
    ThemeContext,
    isAppContext,
    isProductContext,
    isThemeContext
} from '../types/content/context';
import { translatableText } from '../../renderer/utils/translatable-text';

export const getContextName = (
    context: Context | AppContext | ThemeContext
) => {
    if (isProductContext(context)) {
        return context.productNameReference.productName;
    }
    if (isAppContext(context)) {
        return context.appNameReference.appName;
    }

    return context.hubName;
};

export const getRelevantProductNames = (
    context: Context | AppContext | ThemeContext
) => {
    if (isProductContext(context)) {
        return [context.productNameReference.productName];
    }
    if (isAppContext(context)) {
        return (context as AppContext).parentProductContext.items.map(
            ({ internalTitle }) => internalTitle
        );
    }

    return [];
};

export const getSupportTitle = (
    context: Context | AppContext | ThemeContext
) => {
    if (isProductContext(context)) {
        return context.supportTitle;
    }
    if (isAppContext(context)) {
        return context.appNameReference.appName + ' Support';
    }

    return 'Atlassian Support';
};

export const getDeployment = (context: Context | AppContext | ThemeContext) => {
    if (isProductContext(context)) {
        return context.deployment.toLowerCase();
    }
    if (isAppContext(context)) {
        return context.deployment.toLowerCase();
    }

    return null;
};

export const getBreadcrumbTitle = (
    context: Context | AppContext | ThemeContext
) => {
    if (isThemeContext(context)) {
        return `${context.hubName} ${translatableText.resources.text}`;
    }
    return translatableText.resources.text;
};

export const getContextDeploymentForSelectedButton = (context: Context) => {
    if (context.deployment === 'Cloud') {
        return context.deployment;
    } else {
        return 'Data Center and Server';
    }
};
